import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, CardContent, Checkbox, FormControl, FormControlLabel, FormGroup, FormLabel, Grid, Typography } from '@mui/material';
import { ObjectKeyPluckerTable } from '../../generic/KeyPlucker/ObjectKeyPluckerTable';
import { TabPanel } from '../../utils/TabPanelShim';
import React, { useEffect } from 'react';
import { NavSections } from '../../navigation/NavSections';
import { AppLocalStorage } from '../../../data/LocalStorage/AppLocalStorage';
import { flattenObject, timestampToMS, getContainedPopulatedKeys } from '@iotv/datamodel-core';
const debug = process.env.REACT_APP_DEBUG && false;
const unwantedKeys = ['verify'];
export const HistoryTab = ({ value, index, currentDeviceTransactions, selectedDevices }) => {
    const objects = currentDeviceTransactions
        ?.map((item) => {
        const { status, timestamp, initialRequest } = item;
        return { ...flattenObject({ ...(initialRequest?.desiredPayload ?? {}) }), status, timestamp };
    })
        .map((item) => {
        unwantedKeys.forEach((k) => delete item[k]);
        return item;
    })
        .sort((a, b) => (a.timestamp ?? 0) - (b.timestamp ?? 0))
        .reverse()
        .map((item) => ({ ...item, timestamp: item.timestamp ? new Date(timestampToMS(item.timestamp)).toLocaleString() : undefined })) ?? [];
    const selectedDevice = selectedDevices[0]; // originally intended to deal with mutliple selections
    const [userSelectedKeys] = React.useState(AppLocalStorage.get(NavSections.DIAGNOSTIC, 'userSelectedKeysHistoryTab') ?? []);
    const [showAllKeys, setShowAllKeys] = React.useState(false);
    const [containedKeys, setContainedKeys] = React.useState([]);
    useEffect(() => {
        const populatedKeys = getContainedPopulatedKeys(objects ?? []).filter((k) => !['timestamp', ...unwantedKeys].includes(k));
        setContainedKeys(populatedKeys);
        if (!showAllKeys) {
            const filteredUserSelectedKeys = userSelectedKeys.filter((k) => k !== 'timestamp');
            setSelectedKeys(populatedKeys.filter((k) => filteredUserSelectedKeys?.includes(k)));
        }
    }, [objects.length]);
    debug && console.log('userSelectedKeys', userSelectedKeys);
    debug && console.log('containedKeys', containedKeys);
    const [selectedKeys, setSelectedKeys] = React.useState([]);
    const handleToggleShowAllKeys = (e) => {
        setShowAllKeys(e.target.checked);
        debug && console.log('toggle all', { checked: e.target.checked, showAllKeys, selectedKeys });
        e.target.checked ? setSelectedKeys(containedKeys) : setSelectedKeys([]);
    };
    const handleCheckboxChange = (e) => {
        const checked = e.currentTarget.checked;
        const clone = [...selectedKeys];
        if (checked) {
            clone.push(e.currentTarget.value);
        }
        else {
            const idx = selectedKeys.findIndex((key) => key === e.currentTarget.value);
            if (idx !== undefined) {
                clone.splice(idx, 1);
            }
        }
        if (!showAllKeys) {
            AppLocalStorage.set(NavSections.DIAGNOSTIC, 'userSelectedKeysHistoryTab', clone);
            setSelectedKeys(clone);
        }
    };
    return (_jsx(TabPanel, { value, index, children: _jsxs(Grid, { container: true, children: [_jsx(Grid, { size: {
                        xs: 9,
                        lg: 10,
                    }, children: _jsx(Card, { children: _jsxs(CardContent, { children: [_jsx(Typography, { variant: 'h5', children: `${selectedDevice?.name ?? selectedDevice?.sk ?? '?'} Downlinks` }), _jsx(ObjectKeyPluckerTable, { objects, keys: selectedKeys.length > 0 ? ['timestamp', ...selectedKeys] : undefined })] }) }) }), _jsx(Grid, { size: {
                        xs: 2,
                        lg: 2,
                    }, children: _jsx(Card, { children: _jsx(CardContent, { children: _jsxs(FormControl, { size: "small", component: "fieldset", children: [_jsx(FormLabel, { component: "legend", children: "Select keys" }), _jsxs(FormGroup, { children: [_jsx(FormControlLabel, { control: (_jsx(Checkbox, { size: 'small',
                                                    value: showAllKeys,
                                                    checked: showAllKeys,
                                                    onChange: (e) => handleToggleShowAllKeys(e) })),
                                                label: 'All / None' }), containedKeys.map((k, i) => (_jsx(FormControlLabel, { control: (_jsx(Checkbox, { size: 'small', value: k, checked: selectedKeys.includes(k), onChange: handleCheckboxChange, name: `${i}_cb` })),
                                                label: k }, k)))] })] }) }) }) })] }) }));
};
